<template>
    <div class="userBox">
        <div class="contents clear">
            <div class="sexBox fl">
                <div id="sex" class="jz" :style="`width: 144px; height: 144px;`"></div>
                <p class="t">性别分布</p>
                <el-table class="recommendBox" :data="gender" border style="width: 100%">
                    <el-table-column label="性别" align="center" width="100">
                        <template slot-scope="scope">
                            <div class="clear">
                                <!-- <span class="bgColor fl" :style="`background-color: ${genderColorData[scope.row.gender - 1]}`"></span> -->
                                <!-- <span class="name fl">{{genderData[scope.row.gender - 1]}}</span> -->
                                <span class="bgColor fl" :style="`background-color: ${genderColorData[scope.row.gender]}`"></span>
                                <span class="name fl">{{scope.row.gender}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="total" label="用户数" align="center"></el-table-column>
                    <el-table-column prop="level" label="占比" align="center">
                        <template slot-scope="scope">
                            <span>{{Math.round(scope.row.total / genderTotal * 10000) / 100.00 + "%"}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="ageBox fl">
                <div id="age" class="jz" :style="`width: 144px; height: 144px;`"></div>
                <p class="t">年龄分布</p>
                <el-table class="recommendBox" :data="ages" border style="width: 100%">
                    <el-table-column label="年龄" align="center" width="100">
                        <template slot-scope="scope">
                            <div class="clear">
                                <span class="bgColor fl" :style="`background-color: ${agesColorData[scope.row.label]}`"></span>
                                <span class="name fl">{{scope.row.label}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="total" label="用户数" align="center"></el-table-column>
                    <el-table-column prop="level" label="占比" align="center">
                        <template slot-scope="scope">
                            <span>{{Math.round(scope.row.total / agesTotal * 10000) / 100.00 + "%"}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
    data() {
        return {
            option: {
                tooltip: {
                    trigger: 'item'
                },
                series: [{
                    type: 'pie',
                    radius: '80%',
                    center: ['50%', '50%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'outside'
                    },
                    emphasis: {
                        label: {
                            show: false,
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            },
            myChart: null,
            gender: [],
            genderTotal: 0,
            genderData: ['男', '女', '未知'],
            // genderColorData: ['rgba(87, 152, 255, 1)', 'rgba(255, 93, 158, 1)', 'rgba(167, 167, 229, 1)'],
            genderColorData: {
                '男': 'rgba(87, 152, 255, 1)',
                '女': 'rgba(255, 93, 158, 1)',
                '未知': 'rgba(167, 167, 229, 1)',
            },
            ages: [],
            agesTotal: 0,
            agesData: [
                '18岁以下',
                '18-30岁',
                '18-45岁',
                '45岁以上',
            ],
            agesColorData: {
                '18岁以下': '#8D6BFF',
                '18-30岁': '#6B3FFC',
                '18-45岁': '#431DC1',
                '45岁以上': '#361A93',
            }
        }
    },
    methods: {
        setData(res) {
            this.genderTotal = res.result.gender.total
            this.agesTotal = res.result.age.total
            this.gender = res.result.gender.genderList
            this.ages = res.result.age.ageList
            this.sexSet(res.result.gender.genderList)
            this.ageSet(res.result.age.ageList)
        },
        sexSet(data) {
            let sexDataOption = JSON.parse(JSON.stringify(this.option))
            sexDataOption.series[0].name = '性别分布'
            if(data && data.length <= 0) return false;
            data.map(v => {
                sexDataOption.series[0].data.push({
                    value: v.total,
                    name: v.gender,
                    itemStyle: {
                        color: this.genderColorData[v.gender]
                    }
                })
            })
            this.myChart = echarts.init(document.getElementById('sex'));
            this.myChart.clear();//如果图表有修改需求建议加上此方法先清后画
            this.myChart.setOption(sexDataOption);
        },
        ageSet(data) {
            let sexDataOption = JSON.parse(JSON.stringify(this.option))
            sexDataOption.series[0].name = '年龄分布'
            if(data && data.length <= 0) return false;
            data.map(v => {
                sexDataOption.series[0].data.push({
                    value: v.total,
                    name: v.label,
                    itemStyle: {
                        color: this.agesColorData[v.label]
                    }
                })
            })
            this.myChart = echarts.init(document.getElementById('age'));
            this.myChart.clear();//如果图表有修改需求建议加上此方法先清后画
            this.myChart.setOption(sexDataOption);
        }
    },
}
</script>

<style lang="scss" scoped>
.contents{
    width: 878px;
    box-sizing: border-box;
    border-radius: 12px;
    padding: 33px 16px 16px;
}
.title{
    margin-top: 24px;
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
}
.jz{
    margin: 0 auto;
}
.sexBox{
    width: 352px;
    margin-right: 93px;
}
.t{
    margin: 19px 0 45px;
    line-height: 22px;
    font-size: 16px;
    color: #fff;
    text-align: center;
}
.bgColor{
    width: 13px;
    height: 13px;
    margin-right: 5px;
    border-radius: 50%;
    margin-top: 5px;
}
::v-deep .el-table{
    background-color: transparent
}
::v-deep .el-table tr{
    background-color: transparent !important;
    border: none !important;
    
}
::v-deep .el-table th{
    background-color: transparent !important;
    border: none !important;
}
::v-deep .el-table td{
    border: none !important;
    color: #fff;
    border-bottom: 1px solid #2F2F48 !important
}
::v-deep .el-table tbody tr:hover>td {
    background-color: #222236 !important
}
.el-table::before{
    height: 0;
}
.el-table--border::after{
    width: 0;
}
.el-table--border, .el-table--group{
    border: none !important
}
::v-deep thead{
    color: #A1A1CC
}
</style>
